import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {TextSharedQuestion} from "../../sharedQuestions/TextSharedQuestion";

export class TextQuestionComponent {

    protected scope:ng.IScope;
    protected timeout:ng.ITimeoutService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    public sharedQuestion:TextSharedQuestion;

    preventNextQuestion:'false'|'true' = 'false';
    nextQuestionCallback;
    question:IQuestion;
    value:string                       = '';

    editor:{
        multiline:boolean;
        markdown:boolean;
        maxCharacters:number;
    };

    static $inject = ['$scope', '$timeout', 'SharedQuestionService', 'SessionService'];

    constructor($scope:ng.IScope, $timeout:ng.ITimeoutService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.scope                 = $scope;
        this.timeout               = $timeout;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
    }

    public $onInit = () => {
        this.sharedQuestion = new TextSharedQuestion();

        const meta  = this.question.meta;
        this.editor = {
            multiline    : meta && meta.multiline && !meta.markdown,
            markdown     : meta && meta.multiline && meta.markdown,
            maxCharacters: this.question.meta.max_characters
        };

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0 && angular.isObject(answer.values[0])) {
            this.value = answer.values[0].value;
        }

        this.update();
    }

    public update(value?:string) {
        this.sharedQuestion.setValue({
            value: value ? value : this.value
        });

        this.timeout(() => {
            this.scope.$apply();
        });
    }

}

app.component('textQuestion', {
    templateUrl : 'templates/components/questionTypes/textQuestion.html',
    controller  : TextQuestionComponent,
    controllerAs: 'textQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&',
        preventNextQuestion : '@'
    }
});